"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function useClipboard() {
    var copyToClipboard = function (copyText) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(copyText).then(function () {
                // eslint-disable-next-line no-alert
                alert("Link copied to clipboard: ".concat(copyText));
            });
        }
        else {
            var clipBoardElem = document.createElement("input");
            document.body.appendChild(clipBoardElem);
            clipBoardElem.value = copyText;
            clipBoardElem.select();
            var successfulCopy = document.execCommand("copy");
            document.body.removeChild(clipBoardElem);
            if (successfulCopy) {
                // eslint-disable-next-line no-alert
                alert("Link copied to clipboard: ".concat(copyText));
            }
        }
    };
    return {
        copyToClipboard: copyToClipboard,
    };
}
exports.default = useClipboard;
//# sourceMappingURL=index.js.map